// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__zH7X6"};